import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
// import Button from "@mui/material/Button";
import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import avatar from "../../assets/images/Profile-Picture.jpg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DescriptionIcon from '@mui/icons-material/Description';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';

function MobileDrawer() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const DrawerMenu = [
    {
      "name": "Home",
      "icon": <HomeIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileDashboard'
    },
    {
      "name": "My Profile",
      "icon": <PersonIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileProfile'  
    },
    {
      "name": "All Groups",
      "icon": <PeopleIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileGroup'
    },
    {
      "name": "Service Provider",
      "icon": <CleaningServicesIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileServiceProvider'
    },
    {
      "name": "Invoice",
      "icon": <ReceiptIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/Invoice'
    },
    {
      "name": "Notices",
      "icon": <DescriptionIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/NoticeBoard'
    },
    {
      "name": "Resident Directory",
      "icon": <ListAltIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileResidentDirectory'
    },
    {
      "name": "Food Ordering",
      "icon": <LocalDiningIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileFoodOrderOption'
    },
    {
      "name": "Market Place",
      "icon": <LocalGroceryStoreIcon sx={{color: '#111111', fontSize: 25}} />,
      "navigate": '/MobileMarketPlaceBuyer'
    }    
  ]

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      {/* <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider /> */}
      <List className="ListDrawerView">
        {DrawerMenu.map((text, index) => (
          <ListItem key={text.name} disablePadding>
            <ListItemButton onClick={()=>navigate(text.navigate)}>
              <ListItemIcon>
                {text.icon}
              </ListItemIcon>
              <ListItemText primary={text.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  /* <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary={"Inbox"} />
            </ListItemButton>
          </ListItem>
        </List>
        </Box> */

  return (
    <div>
      <IconButton
        aria-label="Menu"
        onClick={toggleDrawer(true)}
        className="drawerBtMob"
      >
        <MenuIcon />
      </IconButton>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <div className="DrawerUserView">
          <div className="DrawerImageNameView"> 
            <img src={avatar} className="DrawerAvatarImage" alt='altimg'/>
            <div>
              <p className="DrawerUserName">User Name</p>
              <div className="DrawerPhoneView">
                <LocalPhoneIcon sx={{color:'#f5f5f5', fontSize:18}} />
                <p>9876543210</p>
              </div>
            </div>
          </div>
        </div>
        {DrawerList}
        <div className="DrawerLogOutView">
          <div className="LogoutView">
            <div>
              <p className="LocationTxt">Location</p>
              <p className="LocationNameTxt">India</p>
            </div>
            <p className="LogoutTxt"><LogoutIcon /> Logout</p>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default MobileDrawer;
